import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorsComponent } from './components/errors/errors.component';
import { PrimeModule } from './primeng/primeng-module';
import { ModalImagePickerComponent } from './modals/modal-image-picker/modal-image-picker.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ModalNewCommunityComponent } from './modals/modal-new-community/modal-new-community.component';
import { ModalJoinCommunityComponent } from './modals/modal-join-community/modal-join-community.component';
import { ModalTravelManagementComponent } from './modals/modal-travel-management/modal-travel-management.component';
import { ModalCommunityUsersComponent } from './modals/modal-community-users/modal-community-users.component';
import { ImagePipe } from './pipes/image.pipe';
import { NotificationColorPipe } from './pipes/notification-color.pipe';
import { PopularComponent } from './components/popular/popular.component';
import { SlugifyPipe } from './pipes/slugify.pipe';
import { UrlService } from './services/url.service';
import { DisplayRolePipe } from './pipes/show-role.pipe';
import { TravelTypePipe } from './pipes/travel-type.pipe';
import { TravelErrorsComponent } from './components/travel-errors/travel-errors.component';
import { ModalNewCompanionComponent } from './modals/modal-new-companion/modal-new-companion.component';
import { DaysAndNightsPipe } from './pipes/days-nights.pipe';
import { CurrencyPipe } from './pipes/currency.pipe';
import { ModalFilePickerComponent } from './modals/modal-file-picker/modal-file-picker.component';
import { BytesPipe } from './pipes/bytes.pipe';
import { TravelCardComponent } from './components/travel-card/travel-card.component';
import { TravelImagePipe } from './pipes/travelPlaceholderImage.pipe';
import { TravelCardMinimalComponent } from './components/travel-card-minimal/travel-card-minimal.component';
import { LeavingComponent } from './components/leaving/leaving.component';
import { RequestComponent } from './components/request/request.component';
import { RoomTypePipe } from './pipes/room-type.pipe';
import { ServiceLabelPipe } from './pipes/service-label.pipe';
import { LeaderComponent } from './components/leader/leader.component';
import { LeaderCarouselComponent } from './components/leader-carousel/leader-carousel.component';
import { PaymentStatusPipe } from './pipes/payment-status.pipe';
import { PaymentMethodPipe } from './pipes/payment-method.pipe';

import { BookingStatusPipe } from './pipes/booking-status.pipe';
import { AvailabilityPluralPipe } from './pipes/availability-plural.pipe';
import { ModalTravelersListComponent } from './modals/modal-travelers-list/modal-travelers-list.component';
import { BookingStatusLabelPipe } from './pipes/booking-status-label.pipe';
import { PaymentStatusLabelPipe } from './pipes/status-label.pipe';
import { ModalShareOnSocialsComponent } from './modals/modal-share-on-socials/modal-share-on-socials.component';
import { LoadingPageComponent } from '../loading-page/loading-page.component';
import { CloudImagePickerComponent } from './modals/cloud-image-picker/cloud-image-picker.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { TravelCardAltComponent } from './components/travel-card-alt/travel-card-alt.component';
import { LeadStatusPipe } from './lead-status.pipe';
import { IsAdvancePipe } from './pipes/is-advance.pipe';
import { BookingPaymentByTypePipe } from './pipes/booking-payment-by-type.pipe';
import { PaymentAmountPipe } from './pipes/payment-amount.pipe';
import { BookingExpiredPipe } from './pipes/booking-expired.pipe';
import { TravelStatusPipe } from './pipes/travel-status.pipe';
import { TravelMenuPipe } from './pipes/travel-menu.pipe';
import { PrintUserNamePipe } from './pipes/print-user-name.pipe';
import { GmgAdhesionCategoryPipe } from './pipes/gmg-adhesion-category.pipe';

@NgModule({
  declarations: [
    ErrorsComponent,
    TravelErrorsComponent,
    TravelCardComponent,
    ModalImagePickerComponent,
    ModalNewCommunityComponent,
    ModalJoinCommunityComponent,
    ModalTravelManagementComponent,
    ModalCommunityUsersComponent,
    ImagePipe,
    NotificationColorPipe,
    PopularComponent,
    SlugifyPipe,
    DisplayRolePipe,
    TravelTypePipe,
    ModalNewCompanionComponent,
    DaysAndNightsPipe,
    CurrencyPipe,
    ModalFilePickerComponent,
    BytesPipe,
    TravelCardComponent,
    TravelImagePipe,
    TravelCardMinimalComponent,
    LeavingComponent,
    RequestComponent,
    RoomTypePipe,
    ServiceLabelPipe,
    LeaderComponent,
    LeaderCarouselComponent,
    PaymentStatusPipe,
    PaymentMethodPipe,
    BookingStatusPipe,
    AvailabilityPluralPipe,
    ModalTravelersListComponent,
    BookingStatusLabelPipe,
    PaymentStatusLabelPipe,
    ModalShareOnSocialsComponent,
    CloudImagePickerComponent,
    FaqsComponent,
    TravelCardAltComponent,
    LeadStatusPipe,
    IsAdvancePipe,
    BookingPaymentByTypePipe,
    PaymentAmountPipe,
    BookingExpiredPipe,
    TravelStatusPipe,
    TravelMenuPipe,
    TravelMenuPipe,
    PrintUserNamePipe,
    GmgAdhesionCategoryPipe,
  ],
  exports: [
    ErrorsComponent,
    TravelErrorsComponent,
    TravelCardComponent,
    ModalImagePickerComponent,
    ModalNewCommunityComponent,
    ImagePipe,
    NotificationColorPipe,
    PopularComponent,
    SlugifyPipe,
    DisplayRolePipe,
    TravelTypePipe,
    DaysAndNightsPipe,
    CurrencyPipe,
    ModalFilePickerComponent,
    BytesPipe,
    TravelImagePipe,
    TravelCardMinimalComponent,
    LeavingComponent,
    RequestComponent,
    RoomTypePipe,
    ServiceLabelPipe,
    LeaderComponent,
    LeaderCarouselComponent,
    PaymentStatusPipe,
    PaymentMethodPipe,
    GmgAdhesionCategoryPipe,
    BookingStatusPipe,
    AvailabilityPluralPipe,
    BookingStatusLabelPipe,
    PaymentStatusLabelPipe,
    ModalShareOnSocialsComponent,
    CloudImagePickerComponent,
    FaqsComponent,
    TravelCardAltComponent,
    LeadStatusPipe,
    BookingPaymentByTypePipe,
    IsAdvancePipe,
    PaymentAmountPipe,
    BookingExpiredPipe,
    TravelStatusPipe,
    TravelMenuPipe,
    PrintUserNamePipe,
  ],
  imports: [
    CommonModule,
    PrimeModule,
    ReactiveFormsModule,
    ImageCropperComponent,
  ],
  providers: [UrlService, SlugifyPipe, BookingPaymentByTypePipe],
})
export class SharedModule {}
